import script from "./AppDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AppDashboard.vue?vue&type=style&index=0&id=70f74250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f74250"]])

export default __exports__